import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import _find from 'lodash/find';
import _isNil from 'lodash/isNil';
import PropTypes from 'prop-types';
// Material UI
import { makeStyles } from '@material-ui/core/styles';
import MuiMenuItem from '@material-ui/core/MenuItem';
import MuiSelect from '@material-ui/core/Select';

const IconSelectRenderedValue = ({ item }) => {
  if (item) {
    const { icon } = item;
    return (
      <icon.type
        {...icon.props}
        style={{
          width: '20px', height: '20px', marginLeft: '4px', marginRight: '8px', marginTop: '-4px', marginBottom: '-4px',
        }}
      />
    );
  }
  return <div />;
};

IconSelectRenderedValue.propTypes = {
  item: PropTypes.shape({
    icon: PropTypes.element.isRequired,
  }),
};

IconSelectRenderedValue.defaultProps = {
  item: null,
};

// Styles
const useStyles = makeStyles(() => ({
  root: {
    paddingRight: 16,
  },
}));

const IconSelect = ({
  value: currentValue, items, withNullItem, autoWidth, disabled, onChange,
}) => {
  // Styles
  const classes = useStyles();

  // Change handler
  const handleChange = onChange ? (e) => onChange(e.target.value) : null;

  // Components props
  const selectProps = {
    value: _isNil(currentValue) ? '' : currentValue, disabled, autoWidth, disableUnderline: true, onChange: handleChange,
  };

  return (
    <MuiSelect
      {...selectProps}
      classes={{ root: classes.root }}
      disabled={disabled}
      renderValue={(value) => (
        <IconSelectRenderedValue item={_find(items, ['value', value])} />
      )}
    >
      {withNullItem && (
        <MuiMenuItem value={null} style={{ height: 36 }} dense>{' '}</MuiMenuItem>
      )}
      {_map(items, ({
        key, value, label, labelId, icon,
      }) => (
        <MuiMenuItem
          key={key}
          value={value}
          dense
          style={{ minWidth: '100px' }}
        >
          <div className="d-flex align-items-center">
            <icon.type
              {...icon.props}
              style={{ marginRight: '16px' }}
            />
            {label || <LocalizedMessage id={labelId} />}
          </div>
        </MuiMenuItem>
      ))}
    </MuiSelect>
  );
};

IconSelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      labelId: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
      icon: PropTypes.element.isRequired,
    }),
  ).isRequired,
  withNullItem: PropTypes.bool,
  autoWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

IconSelect.defaultProps = {
  value: '',
  withNullItem: false,
  autoWidth: true,
  disabled: false,
  onChange: null,
};

export default React.memo(IconSelect);



// WEBPACK FOOTER //
// ./components/core/IconSelect.js